import api from "../services/api";

export const listContactLists = (params = {}) => api.get("/api/contact-lists", { params });
export const getContactList = (id, phone_id) => api.get(`/api/contact-lists/${id}`, { params: { phone_id } });
export const createContactList = (payload) => api.post("/api/contact-lists", payload);
export const updateContactList = (id, payload) => api.put(`/api/contact-lists/${id}`, payload);
export const deleteContactList = (id, phone_id) =>
  api.delete(`/api/contact-lists/${id}`, { params: { phone_id } });

export const getListMembers = (id, params = {}) =>
  api.get(`/api/contact-lists/${id}/members`, { params });
export const addListMembers = (id, payload) =>
  api.post(`/api/contact-lists/${id}/members`, payload);
export const removeListMember = (id, contactId, phone_id) =>
  api.delete(`/api/contact-lists/${id}/members/${contactId}`, { params: { phone_id } });
export const refreshContactList = (id, phone_id) =>
  api.post(`/api/contact-lists/${id}/refresh`, { phone_id });

/**
 * Variable source catalog for the campaign builder's mapping picker.
 * Returns { defaultFields, customFields, computed } scoped to the
 * (account, phone) that owns the list.
 */
export const getListVariableSources = (id, phone_id) =>
  api.get(`/api/contact-lists/${id}/variable-sources`, { params: { phone_id } });
